import React from 'react';
import { TableCell, TableRow } from '../catalyst/table';

function SearchResultPartsBloomfireBusinessLogicCard({
	tableRowNum,
	url_or_note,
	backup_url_or_note,
	businessLogicType,
}) {
	const isBloomfireLink = businessLogicType === 'BLOOMFIRE';
	const primaryLabel = isBloomfireLink ? 'Open Bloomfire Article' : 'Business Logic Note';
	const description = isBloomfireLink
		? 'This recommendation comes from Bloomfire content.'
		: 'This part recommendation is generated by business logic.';

	const handleClick = () => {
		if (isBloomfireLink && url_or_note) {
			window.open(url_or_note, '_blank', 'noopener,noreferrer');
		}
	};

	return (
		<TableRow key={tableRowNum}>
			<TableCell className="cursor-pointer" onClick={handleClick}>
				<div className="flex flex-col gap-2">
					<div className="flex items-center justify-between">
						<span className="text-sm font-semibold text-zinc-800 dark:text-white">
							{primaryLabel}
						</span>
						<span className="rounded-full bg-orange-200 px-2 py-0.5 text-xs font-semibold uppercase text-orange-800">
							{businessLogicType}
						</span>
					</div>
					<p className="text-sm text-zinc-600 dark:text-zinc-300">{description}</p>
					<div className="rounded-md bg-blue-50 p-2 text-xs text-blue-700">
						{backup_url_or_note || url_or_note || 'No additional details provided.'}
					</div>
				</div>
			</TableCell>
		</TableRow>
	);
}

export default SearchResultPartsBloomfireBusinessLogicCard;
